export { default } from "../use-search-base";
